module.exports = __webpack_public_path__ + "static/media/CollegeLife.9ad5df05.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/pages/assets/CollegeLife.mp3
// module id = 349
// module chunks = 0